import {WebGLRenderer} from 'three'
import emittable from './emittable'

export default emittable(
    class Application {
        paused = false
        _children = []


        get children(){
            return [...this._children];
        }

        set children(children){
            this._children = [...children];
            this._children.application = this;
        }

        constructor(container, children = [], rendererSettings = {}) {
            if(container.tagName === 'CANVAS') {
                this.renderer = new WebGLRenderer({antialias:true, alpha:true, canvas:container, ...rendererSettings});
            }else{
                this.renderer = new WebGLRenderer({antialias:true, alpha:true, ...rendererSettings});
                container.append(this.renderer.domElement);
            }

            this.children = [...this.children,...children];
            window.addEventListener('resize',this.handleResize);
            this.handleResize();
            this.startTime = performance.now();
            this.lastFrame = this.startTime;
            this.tick();
        }

        handleResize = () => {
            const {width,height} = this.renderer.domElement.parentElement.getBoundingClientRect();
            this.renderer.setSize( width, height );
            this.emit("resize",width,height);
        }

        destroy(){
            window.removeEventListener('resize',this.handleResize);
            this.emit("destroy");
            this.paused = true;
            cancelAnimationFrame(this.animationFrameHandle);
        }

        tick = ()=>{
            if(this.paused) return;
            const t = performance.now();
            const elapsed = t - this.startTime;
            const delta = t - this.lastFrame;
            this.lastFrame = t;
            // console.log(delta);
            this.emit("tick",delta,elapsed);

            for(const child of this.children) {
                child.camera && this.renderer.render(child,child.camera);
            }

            this.animationFrameHandle = requestAnimationFrame(this.tick);
        }

        emit(eventName,...args){
            for(const child of this.children) {
                child[eventName] && child[eventName](...args);
            }
        }
    }
);